import React, {useState} from 'react';
import {useParams} from "react-router-dom";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {constantsErrorMessages} from "../../../../../Constants";
import {Typography} from "@mui/material";
import ArrivalMaterialPriceUnitTable
    from "../../../../../components/UI/table/warehouse/material/arrival/ArrivalMaterialPriceUnitTable";
import {Box} from "@mui/system";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";

const ArrivalMaterialPriceUnitArchive = () => {
    const profile = JSON.parse(localStorage.getItem("profile"))
    const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
    const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);
    const params = useParams();
    const [alertData, setAlertData] = useState({});

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Заявка на поставку ${params.arrivalMaterial}`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заявки на поставку", href: "/organization/materials-arrival"},
                    {name: "Архив", href: "/organization/materials-arrival-archive"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        {`Заявка на поставку ${params.arrivalMaterial}`}
                    </Typography>
                </Box>
                <ArrivalMaterialPriceUnitTable
                    isBaseCurrency={params.currentCurrency !== baseCurrency}
                    isAlternativeCurrency={params.currentCurrency !== alternativeCurrency}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    handleModalAlert={handleModalAlert}
                    archive={true}
                    params={params}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default ArrivalMaterialPriceUnitArchive;